var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGooglePlayRu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 136,
    height: 40,
    viewBox: "0 0 136 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 136,
    height: 40,
    rx: 4,
    fill: "#1B1D29"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M68.1016 21.8C65.7016 21.8 63.8016 23.6 63.8016 26.1C63.8016 28.5 65.7016 30.4 68.1016 30.4C70.5016 30.4 72.4016 28.6 72.4016 26.1C72.4016 23.5 70.5016 21.8 68.1016 21.8ZM68.1016 28.6C66.8016 28.6 65.7016 27.5 65.7016 26C65.7016 24.5 66.8016 23.4 68.1016 23.4C69.4016 23.4 70.5016 24.4 70.5016 26C70.5016 27.5 69.4016 28.6 68.1016 28.6ZM58.8016 21.8C56.4016 21.8 54.5016 23.6 54.5016 26.1C54.5016 28.5 56.4016 30.4 58.8016 30.4C61.2016 30.4 63.1016 28.6 63.1016 26.1C63.1016 23.5 61.2016 21.8 58.8016 21.8ZM58.8016 28.6C57.5016 28.6 56.4016 27.5 56.4016 26C56.4016 24.5 57.5016 23.4 58.8016 23.4C60.1016 23.4 61.2016 24.4 61.2016 26C61.2016 27.5 60.1016 28.6 58.8016 28.6ZM47.7016 23.1V24.9H52.0016C51.9016 25.9 51.5016 26.7 51.0016 27.2C50.4016 27.8 49.4016 28.5 47.7016 28.5C45.0016 28.5 43.0016 26.4 43.0016 23.7C43.0016 21 45.1016 18.9 47.7016 18.9C49.1016 18.9 50.2016 19.5 51.0016 20.2L52.3016 18.9C51.2016 17.9 49.8016 17.1 47.8016 17.1C44.2016 17.1 41.1016 20.1 41.1016 23.7C41.1016 27.3 44.2016 30.3 47.8016 30.3C49.8016 30.3 51.2016 29.7 52.4016 28.4C53.6016 27.2 54.0016 25.5 54.0016 24.2C54.0016 23.8 54.0016 23.4 53.9016 23.1H47.7016ZM93.1016 24.5C92.7016 23.5 91.7016 21.8 89.5016 21.8C87.3016 21.8 85.5016 23.5 85.5016 26.1C85.5016 28.5 87.3016 30.4 89.7016 30.4C91.6016 30.4 92.8016 29.2 93.2016 28.5L91.8016 27.5C91.3016 28.2 90.7016 28.7 89.7016 28.7C88.7016 28.7 88.1016 28.3 87.6016 27.4L93.3016 25L93.1016 24.5ZM87.3016 25.9C87.3016 24.3 88.6016 23.4 89.5016 23.4C90.2016 23.4 90.9016 23.8 91.1016 24.3L87.3016 25.9ZM82.6016 30H84.5016V17.5H82.6016V30ZM79.6016 22.7C79.1016 22.2 78.3016 21.7 77.3016 21.7C75.2016 21.7 73.2016 23.6 73.2016 26C73.2016 28.4 75.1016 30.2 77.3016 30.2C78.3016 30.2 79.1016 29.7 79.5016 29.2H79.6016V29.8C79.6016 31.4 78.7016 32.3 77.3016 32.3C76.2016 32.3 75.4016 31.5 75.2016 30.8L73.6016 31.5C74.1016 32.6 75.3016 34 77.4016 34C79.6016 34 81.4016 32.7 81.4016 29.6V22H79.6016V22.7ZM77.4016 28.6C76.1016 28.6 75.0016 27.5 75.0016 26C75.0016 24.5 76.1016 23.4 77.4016 23.4C78.7016 23.4 79.7016 24.5 79.7016 26C79.7016 27.5 78.7016 28.6 77.4016 28.6ZM101.802 17.5H97.3016V30H99.2016V25.3H101.802C103.902 25.3 105.902 23.8 105.902 21.4C105.902 19 103.902 17.5 101.802 17.5ZM101.902 23.5H99.2016V19.2H101.902C103.302 19.2 104.102 20.4 104.102 21.3C104.002 22.4 103.202 23.5 101.902 23.5ZM113.402 21.7C112.002 21.7 110.602 22.3 110.102 23.6L111.802 24.3C112.202 23.6 112.802 23.4 113.502 23.4C114.502 23.4 115.402 24 115.502 25V25.1C115.202 24.9 114.402 24.6 113.602 24.6C111.802 24.6 110.002 25.6 110.002 27.4C110.002 29.1 111.502 30.2 113.102 30.2C114.402 30.2 115.002 29.6 115.502 29H115.602V30H117.402V25.2C117.202 23 115.502 21.7 113.402 21.7ZM113.202 28.6C112.602 28.6 111.702 28.3 111.702 27.5C111.702 26.5 112.802 26.2 113.702 26.2C114.502 26.2 114.902 26.4 115.402 26.6C115.202 27.8 114.202 28.6 113.202 28.6ZM123.702 22L121.602 27.4H121.502L119.302 22H117.302L120.602 29.6L118.702 33.8H120.602L125.702 22H123.702ZM106.902 30H108.802V17.5H106.902V30Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.3984 7.5C10.0984 7.8 9.89844 8.3 9.89844 8.9V31C9.89844 31.6 10.0984 32.1 10.3984 32.4L10.4984 32.5L22.8984 20.1V20V19.9L10.3984 7.5Z",
    fill: "url(#paint0_linear_12322_6881)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M26.9984 24.3L22.8984 20.2V20V19.9L26.9984 15.8L27.0984 15.9L31.9984 18.7C33.3984 19.5 33.3984 20.8 31.9984 21.6L26.9984 24.3Z",
    fill: "url(#paint1_linear_12322_6881)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M27.0984 24.2L22.8984 20L10.3984 32.5C10.8984 33 11.5984 33 12.4984 32.6L27.0984 24.2Z",
    fill: "url(#paint2_linear_12322_6881)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M27.0984 15.8L12.4984 7.50001C11.5984 7.00001 10.8984 7.10001 10.3984 7.60001L22.8984 20L27.0984 15.8Z",
    fill: "url(#paint3_linear_12322_6881)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M26.9984 24.1L12.4984 32.3C11.6984 32.8 10.9984 32.7 10.4984 32.3L10.3984 32.4L10.4984 32.5C10.9984 32.9 11.6984 33 12.4984 32.5L26.9984 24.1Z",
    fill: "#333647"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.12,
    d: "M10.4 32.3C10.1 32 10 31.5 10 30.9V31C10 31.6 10.2 32.1 10.5 32.4V32.3H10.4Z",
    fill: "#333647"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.12,
    d: "M32 21.3L27 24.1L27.1 24.2L32 21.4C32.7 21 33 20.5 33 20C33 20.5 32.6 20.9 32 21.3Z",
    fill: "#333647"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M12.5 7.6L32 18.7C32.6 19.1 33 19.5 33 20C33 19.5 32.7 19 32 18.6L12.5 7.5C11.1 6.7 10 7.4 10 9V9.1C10 7.5 11.1 6.8 12.5 7.6Z",
    fill: "black"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M47.1 10.3C47.1 11.1 46.9 11.8 46.3 12.3C45.7 12.9 45 13.2 44.1 13.2C43.2 13.2 42.5 12.9 41.9 12.3C41.3 11.7 41 10.9 41 10.1C41 9.2 41.3 8.5 41.9 7.9C42.5 7.3 43.3 7 44.1 7C44.5 7 44.9 7.1 45.3 7.3C45.7 7.5 46 7.7 46.2 8L45.7 8.5C45.3 8 44.7 7.8 44 7.8C43.4 7.8 42.8 8 42.3 8.5C41.8 8.9 41.6 9.5 41.6 10.2C41.6 10.9 41.8 11.5 42.3 11.9C42.8 12.3 43.3 12.6 44 12.6C44.7 12.6 45.2 12.4 45.7 11.9C46 11.6 46.2 11.2 46.2 10.7H44V9.9H46.9C47.1 10 47.1 10.2 47.1 10.3ZM51.7 7.8H48.9V9.7H51.4V10.4H48.9V12.3H51.7V13H48.2V7H51.7V7.8ZM55 13.1H54.2V7.8H52.5V7.1H56.7V7.8H55V13.1ZM59.7 13.1V7.1H60.5V13.1H59.7ZM63.9 13.1H63.1V7.8H61.4V7.1H65.6V7.8H63.9V13.1ZM73.5 12.3C72.9 12.9 72.2 13.2 71.3 13.2C70.4 13.2 69.7 12.9 69.1 12.3C68.5 11.7 68.2 10.9 68.2 10.1C68.2 9.3 68.5 8.5 69.1 7.9C69.7 7.3 70.4 7 71.3 7C72.2 7 72.9 7.3 73.5 7.9C74.1 8.5 74.4 9.3 74.4 10.1C74.3 11 74 11.7 73.5 12.3ZM69.6 11.8C70 12.3 70.6 12.5 71.2 12.5C71.8 12.5 72.4 12.3 72.8 11.8C73.2 11.3 73.5 10.8 73.5 10.1C73.5 9.4 73.3 8.8 72.9 8.3C72.5 7.8 71.9 7.6 71.3 7.6C70.7 7.6 70.1 7.8 69.7 8.3C69.3 8.8 69 9.3 69 10C69 10.7 69.1 11.4 69.6 11.8ZM75.4 13.1V7.1H76.3L79.2 11.8V7.1H80V13.1H79.3L76.2 8.2V13.2H75.4V13.1Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.2,
    strokeMiterlimit: 10
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_12322_6881",
    x1: 21.7981,
    y1: 8.7097,
    x2: 5.01574,
    y2: 25.4921,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.00657445,
    stopColor: "#00A1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2601,
    stopColor: "#00BEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5122,
    stopColor: "#00D2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7604,
    stopColor: "#00DFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00E3FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_12322_6881",
    x1: 33.8328,
    y1: 20.0014,
    x2: 9.63594,
    y2: 20.0014,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4087,
    stopColor: "#FFBD00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7754,
    stopColor: "#FFA500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9C00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_12322_6881",
    x1: 24.8254,
    y1: 22.2961,
    x2: 2.06714,
    y2: 45.0544,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF3A44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C31162"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_12322_6881",
    x1: 7.29574,
    y1: 0.176205,
    x2: 17.4583,
    y2: 10.3387,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#32A071"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0685,
    stopColor: "#2DA771"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4762,
    stopColor: "#15CF74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8009,
    stopColor: "#06E775"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00F076"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGooglePlayRu);
export default __webpack_public_path__ + "static/media/google-play-ru.b212afd50d43cf063fe846dcf3ab8b65.svg";
export { ForwardRef as ReactComponent };